module.exports = __webpack_public_path__ + "static/media/sign-out.2bc857e9.svg";